import styled from 'styled-components';

import { mediaConfined, mediaWideNavless } from '@xing-com/layout-tokens';
import { spaceL, spaceM, spaceS, spaceXL } from '@xing-com/tokens';
import { Meta } from '@xing-com/typography';

const ArticleEditHeaderContainer = styled.div`
  align-items: center;
  display: flex;
  margin: ${spaceS} 0 ${spaceL};

  @media ${mediaConfined} {
    margin: ${spaceM} 0 ${spaceXL};
  }

  @media ${mediaWideNavless} {
    margin: ${spaceXL} 0;
  }
`;

const ArticleEditHeaderMeta = styled(Meta)`
  flex: 1;
  margin-bottom: 0;
`;

const ArticleEditHeaderButtonsContainer = styled.div`
  display: flex;
  gap: ${spaceL};
  margin-left: ${spaceL};
`;

export const Styled = {
  ArticleEditHeaderContainer,
  ArticleEditHeaderMeta,
  ArticleEditHeaderButtonsContainer,
};
